<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-imageupload`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.9309 4.34189H9.84727C7.60706 4.34189 6.48695 4.34189 5.6313 4.77786C4.87866 5.16136 4.26673 5.77328 3.88324 6.52593C3.44727 7.38157 3.44727 8.50168 3.44727 10.7419V13.7948C3.44727 16.035 3.44727 17.1551 3.88324 18.0107C4.26673 18.7634 4.87866 19.3753 5.6313 19.7588C6.48695 20.1948 7.60705 20.1948 9.84726 20.1948H13.8327C16.0729 20.1948 17.193 20.1948 18.0486 19.7588C18.8013 19.3753 19.4132 18.7634 19.7967 18.0107C20.2327 17.1551 20.2327 16.035 20.2327 13.7948V9.71425" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.07227 16.3838L7.91539 13.7129L9.83695 15.0483L11.7585 16.3838M19.9251 17.2341L13.3085 12.6357L11.5727 13.842" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6523 2.63531V10.0955M20.5081 5.49111L17.6523 2.63531 14.7966 5.49111" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorImageupload',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
